import { OrganizationUnitShiftConfig } from '@scheduling/graphql/types';
import { gql, TypedDocumentNode } from '@common/hooks';
import { ShiftTimesListQueryCgResponse } from '@common/graphql/schema';

export const ShiftTimesList: TypedDocumentNode<
  ShiftTimesListQueryCgResponse,
  ShiftTimesListQueryVariables
> = gql`
  query ShiftTimesList($input: ShiftTimesListInput!) {
    shiftTimesList(input: $input) {
      collection {
        id
        startTime
        endTime
        workloadStartTime
        workloadEndTime
        lunchBreakMinLength
        lunchBreakMaxLength
        lunchBreakDeductionDefault
        duration
        role {
          id
          abbreviation
        }
        workforceGroups {
          id
          name
        }
      }
      metadata {
        totalCount
      }
    }
  }
`;

export type ShiftTimesListQueryVariables = {
  input: {
    organizationUnitId: string;
    pagination?: {
      page: number;
      pageSize: number;
    };
  };
};

export type ShiftTimesListQueryResponse = {
  shiftTimesList: {
    collection: OrganizationUnitShiftConfig[];
    metadata: {
      totalCount: number;
    };
  };
};
